import * as React from 'react';
import Paper from '@material-ui/core/Paper';

const CustomPaper = React.forwardRef((props, ref) => {
    return <Paper ref={ref} {...props} />;
});

export { CustomPaper as Paper };
